<igx-card *ngIf="!hasDied" [ngClass]="['container', message.role]" elevated>
    <igx-icon>error</igx-icon>
    <div class="content">
        {{message.content}}
    </div>
</igx-card>
